import Flickity from "flickity";

export default class BasePostGridSlider {
    autoplay = false;
    infinite = false;
    slider = null;
    sliderContainer = null;
    sliderOptions = {};
    videoPlaying = true;
    selectedIndex = 0;
    loading = true;
    progressBar = null;
    sliderEnd = false;
    postGrid = null;
    currentFilters = { search: "" };
    isLoading = false;
    filtering = false;

    constructor(autoplay, infinite) {
        this.autoplay = autoplay || false;
        this.infinite = infinite || false;
    }

    init() {
        this.sliderContainer = this.$refs.slider;
        const slides = this.sliderContainer.querySelectorAll(".slide");

        this.progressBar = this.$el.querySelector(".progress-bar");

        let options = {
            cellAlign: this.infinite ? "center" : "left",
            contain: true,
            wrapAround: this.infinite,
            prevNextButtons: false,
            pageDots: false,
            groupCells: true,
            on: {
                ready: () => {
                    window.dispatchEvent(new Event("resize"));
                    this.sliderResize();
                },
                settle: () => {
                    this.updateTabIndexes(slides);
                    this.updateSliderEnd();
                },
                change: () => {
                    this.selectedIndex = this.slider.selectedIndex;
                },
                scroll: (progress) => {
                    if (this.progressBar) {
                        progress = Math.max(0.25, Math.min(1, progress));
                        this.progressBar.style.width = progress * 100 + "%";
                    }
                },
            },
        };

        if (this.autoplay && this.autoplay > 0) {
            options.autoPlay = this.autoplay * 1000;
        }

        this.sliderOptions = options;

        this.slider = new Flickity(this.sliderContainer, this.sliderOptions);

        pegasus.onResizeFinished(() => {
            this.sliderResize();
        }, false);

        this.updateTabIndexes(slides);

        this.postGrid = this.$el;
        this.getCurrentFilters();
    }

    sliderResize() {
        const flickitySliders = document.querySelectorAll(
            ".Post__Grid-slider .flickity-slider"
        );

        this.sliderFullWidth = 0;

        flickitySliders.forEach((slider) => {
            const slides = slider.querySelectorAll(".slide");
            let height = 0;

            slides.forEach((slide) => {
                slide.style.height = "";
                this.sliderFullWidth += slide.offsetWidth;
                if (slide.offsetHeight > height) {
                    height = slide.offsetHeight;
                }
            });

            slides.forEach((slide) => {
                slide.style.height = height + "px";
            });

            slider.style.height = "";
            slider.style.height = height + "px";
        });
    }

    /**
     * updateSliderEnd
     *
     * Description: Updates sliderEnd property based on whether the slider is at the end or not.
     */
    updateSliderEnd() {
        const selectedIndex = this.slider.selectedIndex;
        const slideCount = this.slider.slides.length;
        this.sliderEnd = selectedIndex === slideCount - 1;
    }

    /**
     * updateTabIndexes
     *
     * Description: Updates the tabindexes of the slides this is required for accessibility.
     * Inactive slides shouldn't be accessible via the keyboard.
     *
     * @param {} slides
     * @return void
     */
    updateTabIndexes(slides) {
        slides.forEach((slide) => {
            const slideElements = slide.querySelectorAll("a, button");

            slideElements.forEach((element) => {
                if (slide.classList.contains("is-selected")) {
                    element.removeAttribute("tabindex");
                } else {
                    element.setAttribute("tabindex", "-1");
                }
            });
        });
    }

    buildURL() {
        let url =
            window.location.protocol +
            "//" +
            window.location.hostname +
            window.location.pathname +
            "?";
        let i = 1;
        for (const [key, value] of Object.entries(this.currentFilters)) {
            url += `${key}=${value}`;
            if (i < Object.keys(this.currentFilters).length) {
                url += "&";
            }
            i++;
        }

        return url;
    }

    toggleFilter(taxonomy, term, multiple = true) {
        if (typeof this.currentFilters[taxonomy] === "undefined") {
            this.currentFilters[taxonomy] = term;
            this.fetchContent();
            return;
        }

        if (this.currentFilters[taxonomy].length) {
            if (this.currentFilters[taxonomy].includes(term)) {
                this.currentFilters[taxonomy] = this.removeFilter(
                    taxonomy,
                    term
                );
                if (!this.currentFilters[taxonomy].length) {
                    delete this.currentFilters[taxonomy];
                }
            } else {
                if (multiple) {
                    this.currentFilters[taxonomy] += "," + term;
                } else {
                    this.currentFilters[taxonomy] = term;
                }
            }
        } else {
            this.currentFilters[taxonomy] = term;
        }

        this.fetchContent();
    }
    clearFilters() {
        this.currentFilters = { search: "" };
        this.fetchContent();
        this.filtering = false;
    }
    removeFilter(filter, value) {
        const filterValue = this.currentFilters[filter];
        const filterValueArray = filterValue.split(",");

        for (let i = 0; i < filterValueArray.length; i++) {
            if (filterValueArray[i] === value) {
                filterValueArray.splice(i, 1);
            }
        }

        return filterValueArray.toString();
    }
    clearFilter(filter) {
        if (typeof this.currentFilters[filter] === "undefined") {
            return;
        }

        if (this.currentFilters[filter].length) {
            delete this.currentFilters[filter];
        }

        this.fetchContent();
    }
    fetchContent() {
        const elements = ["data-pegasus-filterable"];

        this.isLoading = true;

        pegasus.ajaxContent(this.buildURL(), elements, {}, () => {
            this.isLoading = false;

            this.items = document.querySelectorAll(
                "[data-pegasus-single-card]"
            ).length;
            this.sliderContainer = this.$refs.slider;
            this.slider = new Flickity(
                this.sliderContainer,
                this.sliderOptions
            );
            this.updateSliderEnd();
            window?.allModals()?.init();

            if (Object.keys(this.currentFilters).length === 1) {
                this.filtering = false;
            } else {
                this.filtering = true;
            }
        });
    }
    getCurrentFilters() {
        const url = new URL(window.location.href),
            params = new URLSearchParams(url.search);

        for (const [key, value] of params.entries()) {
            this.currentFilters[key] = value;
        }

        if (Object.keys(this.currentFilters).length > 1) {
            //this.removeOtherPostGrids();
            this.filtering = true;
        }
        const slides = this.sliderContainer.querySelectorAll(".slide");
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data(
        "postGridSlider",
        (autoplay, infinite) => new BasePostGridSlider(autoplay, infinite)
    );
});

document.addEventListener("alpine:init", () => {
    Alpine.data("testimonialBreak", () => ({
        open: false,
        init() {},
        contentHeight() {
            window.dispatchEvent(new Event("resize"));
        },
    }));
});
